<template>
    <div>
    <div @click="$emit('close')" class="w-full h-[100vh] absolute top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
    </div>
    <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
        <div class="flex flex-col justify-center  z-40 bg-white w-[1000px] text-lg rounded-lg border-[2px] border-[#006A00] relative">
        
        <div class="pafcpic_header bg-[#006A00] py-3 px-6 ">
            <p class="text-[#ffffff] text-md font-semibold">{{ data.employee_name }} (CY:{{ data.calender_year }})</p>
        </div>
        <div class="pafcpic_body w-full">
            <div class="flex gap-5 text-sm text-[#006A00] font-bold px-5 py-2 items-center">
                <div class="w-[140px] h-[120px]">
                    <div v-if="loadingprofile" class="absolute object-cover bg-[#00000042]  w-[117px] h-[120px] rounded-lg	   flex justify-center items-center z-10" >
                        <span class="loader z-50"></span>
                    </div>
                    <img :src="url"  class=" object-cover w-full bg-[#463a3a] h-[120px] rounded-lg " >
                </div>
              
                <div class="flex w-full gap-[20%] px-10">
                    <div>
                        <p>EMPLOYEE NO: {{ data.employee_key }}</p>
                    </div>
                    <div>
                        <p>LEAVE CREDIT:  {{ data.leave_credit }} DAY(S) {{ data.leave_credit_time }} HOURS</p>
                    </div>
                </div>
            </div>
            <div class="w-full h-[300px] bg-[#D3D3D3] overflow-auto ">
                    <table class="w-full  ">
                        <div v-if="loading" class="absolute bg-[#00000042] w-full h-[300px] flex justify-center items-center z-0" >
                            <span class="loader z-50"></span>
                        </div>
                        <tr class="">
                            <th  class="text-white text-xs font-medium" v-for="(header,index) in header" :key="index">{{ header }}</th>
                        </tr>
                        <tbody class="h-[20px]">
                            <tr class="bg-[#D3D3D3] text-[12px] py-" v-for="(data,index) in columnData" :key="index">
                                    <td v-if="data.from_date === data.to_date">{{ data.from_date }}</td>
                                    <td v-else ><div class="flex flex-col items-center"><span >{{ data.from_date+ "-"}}</span><span >{{ data.to_date }}</span></div></td>
                                    <td>{{ data.particular}}</td>
                                    <td>{{ data.days    }}</td>
                                    <td>{{ data.undertime}}</td>
                                    <td>{{ data.late    }}</td>
                                    <td>{{ data.balance }}</td>
                                    <td>{{ data.remarks }}</td>
                                    <!-- <EditButton class="mr-2"/> -->
                                    
                                <td class=""><EditButton @click="$emit('editLeaveRecord',data.id,data.from_date,data.to_date,data.particular,data.days,data.undertime,data.late,data.remarks)"/><DeleteButton class="ml-2" @click="$emit('deleteLeaveRecord',data.id)"/></td>
                            </tr>
                        </tbody>
                    </table>
            </div>
            <div class="bg-[#8C8C8C] py-4 text-white flex px-[10%] justify-between text-sm font-semibold">
                <p class="text-xs">
                    ACCUMULATED LEAVE: 
                    {{ ConvertedAccumulated }}
                </p>
                <p class="text-xs">REMAINING LEAVE: 
                    {{ RemainingBalance }}
                </p>
            </div>
        </div>
        <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#0080002a] border-t">
                <button @click="$emit('addLeaveRecord')" class="text-sm text-white bg-[#006A00] font-semibold py-2 px-10 rounded-md">Add</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 font-semibold px-10 rounded-md" @click="$emit('close')">Close</button>
        </div>
        </div>
        </div>
    </div>
    </template>

    <script>
    import { defineComponent } from 'vue';
    import Services from "../../../services/admin"
    import EditButton from "../../controls/Button/EditControl.vue"
    import DeleteButton from "../Button/DeleteControl.vue"

    export default defineComponent({
        components:{
            EditButton,
            DeleteButton

        },
        data() {
        return {
            loadingprofile:false,
            header:['DATE','PARTICULARS','DAYS','UNDERTIME','LATE','BALANCE','REMARKS','ACTION'],
            columnData:'',
            //FROM DATABASE
            LeaveCreditDay:30,
            LeaveCreditHour:'00:00',
            //DB END
            Balance:[],
            accumulated:0,
            days:null,
            hourFormat:'',

            CreditDays:0,
            CreditUndertime:0,
            CreditLate:0,

            CreditMinutes:0,
            
            //CREDIT BALANCE PER ROW
            CreditBalance:0,

            //TOTAL LEAVE CREDIT USER
            TotalLeaveCredit:0,

            //ACCUMULATED 
            ConvertedAccumulated:0,

            //REMAINING BALANCE
            RemainingBalance:'',


            data:'',
            leaverecord_no:'',
            GetName:'',


            formatHour:'',
            formatMinutes:'',

            loading:false,
            url:"https://ritm.gov.ph/wp-content/uploads/2021/11/blank-profile-picture.png",
            employee_key:'',

        }
        },
        mounted(){
            this.data             = this.Information
            this.LeaveCreditDay   = this.data.leave_credit
            this.LeaveCreditHour  = this.data.leave_credit_time
            this.leaverecord_no   = this.data.leaverecord_no
            this.employee_key     = this.data.employee_key
            this.getDisplaypicture()
            this.getLeaveRecord()
       

            this.getEmployeeName()
          
         
        },
        props:{
            Information:{
                type: Object,
            }
        },
        methods:{
            async getDisplaypicture(){
                let that = this
                this.loadingprofile = true
                
                const success =  await Services.getDisplayPicture(this.employee_key)
                const test = success.success

                if(test == true){
                    // this.url    = "data:image/png;base64,"+ success.data.data.image
                    that.url = "data:image/png;base64,"+ success.data.image
                }
                else{
                    that.url ="https://ritm.gov.ph/wp-content/uploads/2021/11/blank-profile-picture.png"
                    that.loadingprofile = false
                }

                that.loadingprofile = false
                
          
            },
            async getEmployeeName(){
                this.$emit("showLoader")
                const success    =  await Services.getEmployeeName()
                this.GetName     =  success.data
             },
            async getLeaveRecord(){
                this.loading = true
                this.accumulated = 0
                this.ConvertedAccumulated = 0
                this.Balance = []
                const success           = await Services.getLeaveRecord(this.leaverecord_no);
                this.columnData         = success.data
                this.LeaveRecord()
                this.loading = false
                 
            },
            LeaveRecord(){
                const LeaveCredit      = this.LeaveCreditDay * 480
                const LeaveHours       = this.convertHourstoMinutes(this.LeaveCreditHour)
                this.TotalLeaveCredit  = LeaveCredit + LeaveHours

                this.RemainingBalance  = this.minutedToDandH(this.TotalLeaveCredit)

                for (var LeaveCredits of this.columnData){

                    

                    this.CreditDays = Number(LeaveCredits.days) * 480
                 

                    if(LeaveCredits.undertime != null){
                        this.CreditUndertime    = this.convertHourstoMinutes(LeaveCredits.undertime)
                    }
                   
                    if(LeaveCredits.late != null){
                        this.CreditLate         = this.convertHourstoMinutes(LeaveCredits.late)
                    }

                    this.CreditMinutes = this.CreditDays + this.CreditUndertime + this.CreditLate 
                    this.accumulated +=  this.CreditMinutes

                    this.CreditBalance = this.TotalLeaveCredit - this.CreditMinutes
                    this.TotalLeaveCredit -= this.CreditMinutes
                    
                    this.Balance.push({ balance: this.minutedToDandH(this.CreditBalance) });

                    this.RemainingBalance = this.minutedToDandH(this.CreditBalance)
                   

                    this.CreditDays       = 0
                    this.CreditUndertime  = 0
                    this.CreditLate       = 0
                    this.CreditBalance    = 0
                }
                
                for (let i = 0; i < this.columnData.length; i++) {
                    const balance = this.Balance[i].balance;
                    this.columnData[i].balance = balance ;
                }

                this.ConvertedAccumulated = this.minutedToDandH(this.accumulated)
                  
                },
            convertHourstoMinutes(Leavehour){
                const hrtom  = Leavehour.split(":")

                return Number(hrtom[0]) * 60 + Number(hrtom[1]);
            },
            minutedToDandH(balance){
                let toDays = balance;
                let days  = 0;
                let hours = 0;

               if(toDays < 0){
                    let toDaysnegative = Math.abs(toDays)
                    while (toDaysnegative >= 480) {
                        days += 1;
                        toDaysnegative -= 480;
                    }
                    while (toDaysnegative >= 60){
                        hours +=1
                        toDaysnegative -=60
                    }
                   
                    if(hours > 0){
                        this.formatHour = hours + " HOUR(S) "
                    }
                    else{
                        this.formatHour = ' '
                    }
                    if(toDaysnegative > 0){
                        this.formatMinutes = toDaysnegative + " MINUTES(S) "
                    }
                    else{
                        this.formatMinutes === ' '
                    }
                    let and = ''
                    if (hours > 0 && toDaysnegative > 0){
                         and = 'AND '
                    }
                    else{
                        and = ''
                    }
                    
                    return this.balanceFormat = "-" + days + " DAY(S) " + this.formatHour + and + this.formatMinutes
               }
               else{
                    while (toDays >= 480) {
                        days += 1;
                        toDays -= 480;
                    }
                    while (toDays >= 60){
                        hours +=1
                        toDays -=60
                    }
                    if(hours > 0){
                        this.formatHour = hours + " HOUR(S) "
                    }
                    else{
                        this.formatHour = ''
                    }
                    if(toDays > 0){
                        this.formatMinutes = toDays + " MINUTES(S) "
                    }
                    else{
                        this.formatMinutes = ''
                    }

                    let and = ''

                    if (hours > 0 && toDays > 0){
                         and = 'AND '
                    }
                    else{
                        and = ''
                    }

                    return this.balanceFormat = days + " DAY(S) " + this.formatHour + and + this.formatMinutes
               }    
            }}
})
    </script>

    <style scoped>
        table tr th{
            background-color: #006A00;
            padding: 15px 0px;
            position:sticky;
            top:0;
        }
        tr td{
            height: 20px;
            text-align: center;
            padding: 10px 1px;
            color: #5f615f;
            border-bottom: 1px solid rgb(177, 175, 175);
            font-weight: 600;

        }
        .loader {
            width: 30px;
            height: 30px;
            border: 5px solid #ffffff;
            border-bottom-color: transparent;
            border-radius: 50%;
       
            box-sizing: border-box;
            animation: rotation 1s linear infinite;
            }
        
            @keyframes rotation {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
            } 
    </style>